<template>
    <div class="ScenarioHistory">
        <div class="page-header">
            <div class="btn-custom-normal mr-12" style="width: 32px" @click="backToScenario" :title="$f.tc('back')">
                <img src="/img/scenario/back.svg" alt="icon-back" style="transform: scale(1.2)">
            </div>
            <div class="page-title">
                {{ $f.tc('history') }} -
                <span v-if="agent" @click="backToScenario" class="name">{{ agent.name }}</span>
            </div>
            <div class="btn-icon ml-6" @click="resetSearch">
                <v-icon color="#727885" size="24">mdi-refresh</v-icon>
            </div>
        </div>
        <v-layout class="ScenarioHistoryBody">
            <!--List chats-->
            <div class="ScenarioHistoryBodyLeft">
                <div class="px-12" style="padding-top: 12px">
                    <TimeRangePicker
                        ref="TimeRangePicker"
                        v-model="timeRange"
                    ></TimeRangePicker>
                </div>
                <div class="centerY mt-8 px-12" style="gap: 8px">
                    <div
                        v-for="item in historyTypes"
                        :key="item.value"
                        class="filter-chip"
                        :class="item.value === filters.type ? 'chip-activated' : ''"
                        @click="selectType(item)"
                    >
                        {{ item.text }}
                    </div>
                </div>
                <div style="position: relative; border-bottom: 1px solid #E4EDFA; padding-bottom: 12px"
                     class="mt-8 px-12">
                    <v-text-field
                        hide-details
                        v-model="searchKey"
                        :placeholder="$f.tc('searchBy.phoneNameCallId')"
                        @focusout="resetSearch"
                        @keypress.enter="resetSearch"
                        class="input-custom"
                    ></v-text-field>
                    <img
                        src="/img/scenario/search.svg"
                        style="position: absolute; right: 20px; top: 5px; transform: scale(0.8); cursor: pointer"
                        @click="resetSearch"
                        alt="icon-search">
                </div>
                <div class="log-container fci-scrollbar" ref="LogContainer" v-on="scrollHandlers">
                    <div v-if="callList.length === 0 && !loading" class="centerXY no-data">
                        <img src="/img/debug/not-found.svg" alt="icon-not-found">
                        <div class="no-data-title">
                            {{ $f.tc('noDataAvailable') }}
                        </div>
                        <div class="no-data-des">
                            {{ $f.tc('notFoundCall') }}
                        </div>
                    </div>
                    <div
                        v-else
                        v-for="(call, i) in callList"
                        :key="i"
                        class="log-item"
                        @click="loadCallMessage(call)"
                        :class="{active: call.id === activeCall.id}"
                    >
                        <v-layout class="log-item-phone">
                            <div class="log-item-name">{{ call.name }}</div>
                            <v-spacer></v-spacer>
                            {{ call.created_time | formatDateTime }}
                        </v-layout>
                        <div class="log-item-phone">
                            {{ call.phone }}
                        </div>
                        {{ call.id }}
                    </div>
                    <v-layout justify-center v-if="loading" class="px-20 py-12">
                        <v-icon class="tm-spin">mdi-loading</v-icon>
                    </v-layout>
                </div>
            </div>
            <!--Content Chat-->
            <div style="overflow: hidden; flex: 1">
                <!--Title Chat-->
                <div class="px-12 py-12" style="border-bottom: 1px solid #e4edfa;" v-if="activeCall.id">
                    <div class="display-flex align-center justify-space-between mb-8">
                        <!--List actions for history-->
                        <div class="display-flex align-center">
                            <!--Button copy call ID-->
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="btn-tag" @click="copyText(activeCall.id)" v-on="on">
                                        <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                             style="width: 16px; margin-right: 3px">
                                        {{ $f.tc('botHistory.callId') }}
                                    </div>
                                </template>
                                <span>{{ activeCall.id }}</span>
                            </v-tooltip>
                            <!--Button copy customer name-->
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="btn-tag" @click="copyText(activeCall.name)" v-on="on">
                                        <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                             style="width: 16px; margin-right: 3px">
                                        {{ $f.tc('botHistory.customerName') }}
                                    </div>
                                </template>
                                <span>{{ activeCall.name }}</span>
                            </v-tooltip>
                            <!--Button copy customer phone-->
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="btn-tag" @click="copyText(activeCall.phone)" v-on="on">
                                        <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                             style="width: 16px; margin-right: 3px">
                                        {{ $f.tc('botHistory.customerPhone') }}
                                    </div>
                                </template>
                                <span>{{ activeCall.phone }}</span>
                            </v-tooltip>
                            <!--Button copy customer phone-->
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <div class="btn-tag" @click="copyText($f.formatDateTime(activeCall.created_time))"
                                         v-on="on">
                                        <img src="/img/scenario/copy_blue.svg" alt="icon-copy"
                                             style="width: 16px; margin-right: 3px">
                                        {{ $f.tc('botHistory.createdTime') }}
                                    </div>
                                </template>
                                <span>{{ $f.formatDateTime(activeCall.created_time) }}</span>
                            </v-tooltip>
                        </div>
                        <div class="display-flex align-center">
                            <div class="btn-icon-2" style="margin-right: 3px" @click="downloadAudio"
                                 v-if="activeCallAudioData">
                                <img src="/img/scenario/download.svg" alt="icon-download" style="transform: scale(1.2)">
                            </div>
                            <div class="btn-icon-2" style="margin-right: 3px" @click="loadCallMessage(activeCall)">
                                <v-icon color="#727885" size="24">mdi-refresh</v-icon>
                            </div>
                            <v-menu
                                offset-y
                            >
                                <template v-slot:activator="{ attrs, on }">
                                    <div class="btn-icon-2 btn-menu" v-bind="attrs" v-on="on">
                                        <img src="/img/scenario/menu.svg" alt="icon-menu"
                                             style="transform: scale(1.05)">
                                    </div>
                                </template>
                                <v-list>
                                    <v-list-tile
                                        v-for="action in historyActions"
                                        :key="action.id"
                                        @click="onAction(action.id)"
                                    >
                                        <v-list-tile-title
                                            v-text="action.text"
                                        ></v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                    <div class="call-audio" v-if="activeCall && activeCall.id">
                        <audio :src="activeCallAudioSrc" controls="controls" :title="activeCall.id" ref="audio"></audio>
                    </div>
                </div>
                <div v-else class="centerXY" style="width: 100%; height: 100%">
                    <div style="font-family: 'open sans semi',serif; font-size: 16px">
                        <img src="/img/scenario/history_chat.svg" alt="icon-history-chat" style="width: 220px">
                        <div style="text-align: center; color: #545253; margin-top: -18px">
                            {{ $f.tc('noDataAvailable') }}
                        </div>
                    </div>
                </div>
                <!--Icon Loading-->
                <div v-if="loadingMessage" class="centerXY" style="width: 100%; height: 100%">
                    <v-icon class="tm-spin">mdi-loading</v-icon>
                </div>
                <!--List message-->
                <div v-else class="message-scroll px-12 py-12 fci-scrollbar" ref="MessageScroll">
                    <div v-for="(item, j) in activeHistoryBot.messageList" :key="j"
                         :style="[j !== 0 ? {marginTop: '12px'} : '']">
                        <div v-if="item.type === 'user'" class="message-container user">
                            <div class="message user" style="max-width: 70%">
                                {{ item.content }}
                            </div>
                        </div>
                        <div class="message-container bot" v-else>
                            <div style="width: 40px"
                                 v-if="j > 0 && activeHistoryBot.messageList[j - 1].type === 'bot'"></div>
                            <div class="message-icon-container" v-else>
                                <img src="/img/scenario/process_active.svg" alt="bot">
                            </div>
                            <div style="max-width: 70%">
                                <v-tooltip top
                                           v-if="item['quick_reaction_mode'] || isInputRailsAnswer(item['input_rails_topic'])||item['bot_actions']">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" class="message bot mx-2">
                                            <div v-if="!item['interrupt_text']">
                                                {{ item.content }}
                                            </div>
                                            <div v-else>
                                                <span>{{ item['interrupt_text'] }}</span>
                                                <span style="color: #9cadac">{{ item['no_speak_text'] }}</span>
                                            </div>

                                        </div>
                                    </template>
                                    <div v-if="item['quick_reaction_intent']">
                                        <span>Quick reaction intent: {{ item['quick_reaction_intent'] }}</span>
                                    </div>
                                    <div v-if="isInputRailsAnswer(item['input_rails_topic'])">
                                        <span>Input rails topic: {{ item['input_rails_topic'] }}</span>
                                    </div>
                                    <div v-if="item['bot_actions']">
                                        <span>Agent actions:</span>
                                        <ul>
                                            <li v-for="(i, index) in item['bot_actions']" :key="index">
                                                {{ i }}
                                            </li>
                                        </ul>
                                    </div>
                                </v-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-layout>
        <SampleEditor ref="SampleEditor"></SampleEditor>
    </div>
</template>

<script>
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import SampleEditor from '@/views/Scenario/nlp/SampleEditor'
import {mapState} from 'vuex'
import $const from '@/utils/const'
import AgentService from "@/services/agent.service";
import ScenarioService from "@/services/scenario.service";

const ACTIONS_HISTORY = {
    COPY_CHAT_HISTORY: 'COPY_CHAT_HISTORY',
    TEST_CHAT_HISTORY: 'TEST_CHAT_HISTORY',
}

export default {
    name: 'AgentHistory',
    components: {SampleEditor, TimeRangePicker},
    data() {
        return {
            agent: null,
            callList: [],
            activeCall: {},
            activeCallAudioSrc: null,
            activeCallAudioData: null,
            timeRange: 'today',
            searchKey: '',
            filters: {
                type: $const.HistoryTypes.ALL
            },
            scrollId: '',
            activeHistoryBot: {
                variableList: [],
                messageList: []
            },
            loading: false,
            loadingMessage: false,
            page: 1,
            page_size: 20,
            scrollEnd: false,
            scrollHandlers: {
                scroll: e => {
                    let element = e.target
                    let maxScrollTop = element.scrollHeight - element.clientHeight
                    if (maxScrollTop - 5 <= element.scrollTop) {
                        if (this.loading || this.scrollEnd) {
                            return
                        }
                        this.page++
                        this.search()
                    }
                }
            },
            isEditable: false,
            ACTIONS_HISTORY,
            audioMap: {}
        }
    },
    computed: {
        ...mapState({}),
        historyActions() {
            return [
                {
                    id: ACTIONS_HISTORY.COPY_CHAT_HISTORY,
                    text: this.$f.tc('copy') + ' ' + this.$t('chat')
                },
                {
                    id: ACTIONS_HISTORY.TEST_CHAT_HISTORY,
                    text: this.$f.tc('reappear') + ' ' + this.$t('chat')
                }
            ]
        },
        historyTypes() {
            return [
                {
                    text: this.$f.tc('all'),
                    value: $const.HistoryTypes.ALL
                },
                {
                    text: this.$f.tc('callOnly'),
                    value: $const.HistoryTypes.CALL
                },
                {
                    text: this.$f.tc('chatOnly'),
                    value: $const.HistoryTypes.CHAT
                }
            ]
        },
    },
    mounted() {
        let stateScenario = this.$store.state.agent.agent
        let id = this.$route.params.agentId
        if (stateScenario && stateScenario.id === id) {
            this.agent = stateScenario
        } else {
            AgentService.CRUD.read(id).then(
                result => this.agent = result.data,
                this.$appService.handleRequestError(' can not load agent')
            )
        }
        this.searchKey = this.$route.query.call_id || ''


        this.resetSearch()
    },
    methods: {
        backToScenario() {
            this.$router.push(`/agents/${this.$route.params.agentId}`)
        },
        search() {
            this.loading = true
            return AgentService.HistoryService.search(this.$route.params.agentId, {
                ...this.$refs.TimeRangePicker.getTimestamp(),
                search: this.searchKey,
                type: this.filters.type,
                page: this.page,
                page_size: this.page_size
            }).then(
                result => {
                    if (result.data.data.length > 0) {
                        let nextCallList = result.data.data.map(call => ({
                            ...call,
                            name: call.name || '---unknown---',
                            phone: call.phone || '---unknown---'
                        }))
                        this.callList = this.$lodash.uniqBy(this.callList.concat(nextCallList), item => item.id)
                        if (this.activeCall && !this.callList.find(item => item.id === this.activeCall.id)) {
                            this.activeHistoryBot.messageList = []
                        }
                    } else {
                        this.scrollEnd = true
                        if (this.page > 1) {
                            this.page--
                        }
                    }
                }
            ).finally(() => {
                this.loading = false
            })
        },
        loadCallMessage(call) {
            this.activeCall = call

            // load audio
            if (this.$refs.audio) {
                this.$refs.audio.pause()
                this.$refs.audio.currentTime = 0
            }

            this.activeCallAudioSrc = ''
            ScenarioService.getCallAudio(this.activeCall.id).then(
                result => {
                    this.activeCallAudioData = result.data
                    this.activeCallAudioSrc = window.URL.createObjectURL(new Blob([result.data], {type: 'audio/wav'}))
                }
            )

            // load messages
            this.loadingMessage = true
            AgentService.HistoryService.read(this.$route.params.agentId, call.id).then(
                result => {
                    this.activeHistoryBot.messageList = result.data
                }
            ).finally(() => {
                if (this.activeCall.id === call.id) {
                    this.loadingMessage = false
                }
            })
        },
        resetSearch() {
            this.page = 1
            this.callList = []
            this.scrollEnd = false
            this.search().then(() => {
                if (this.callList.length > 0 && this.treeData) {
                    this.loadCallMessage(this.callList[0])
                } else {
                    this.activeCall = {}
                }
            })
        },
        downloadAudio() {
            this.$utils.downloadFileFromBlob(this.activeCallAudioData, this.activeCall.id + '.wav')
        },
        copyText(text) {
            this.$utils.copyToClipboard(text, this.$f.tc('copied'))
        },
        onAction(idAction) {
            switch (idAction) {
                case ACTIONS_HISTORY.COPY_CHAT_HISTORY:
                    this.copyChatHistory()
                    break
                case ACTIONS_HISTORY.TEST_CHAT_HISTORY:
                    this.testChatHistory()
                    break
            }
        },
        copyChatHistory() {
            this.$utils.copyToClipboard(JSON.stringify(this.activeHistoryBot), this.$f.tc('copyHistorySuccess'))
        },
        testChatHistory() {
            this.$router.push({
                name: 'AgentDetail',
                params: {historyBot: JSON.stringify(this.activeHistoryBot)}
            })
        },
        validURL(str) {
            let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
            return !!pattern.test(str)
        },
        canPlayAudio(audioLink) {
            if (this.validURL(audioLink)) {
                let ext = audioLink.split(/[#?]/)[0].split('.').pop().trim()
                if (ext === 'wav' || ext === 'mp3') {
                    return true
                }
            }
            return false
        },
        selectType(item) {
            this.filters.type = item.value
            this.resetSearch()
        },
        isInputRailsAnswer(inputRailsTopic) {
            return !(inputRailsTopic === undefined || inputRailsTopic === "" || inputRailsTopic === "others");
        }
    },
    watch: {
        timeRange: 'resetSearch',
        'activeHistoryBot.messageList': function () {
            this.$nextTick(() => {
                let el = this.$refs.MessageScroll
                if (el) {
                    el.scrollTop = el.scrollHeight
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import "../Scenario/chat.scss";

.page-header {
    height: 60px;
    display: flex;
    align-items: center;
    background: #FFFFFF !important;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;

    .page-title {
        font-family: "open sans bold", serif;
        font-size: 22px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 42px 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.message-scroll {
    height: calc(100vh - 255px);
    overflow: auto;
}

.name {
    color: #0052CC;
    cursor: pointer;
}

.ScenarioHistoryBody {
    height: calc(100vh - 160px);
    margin: 20px;
    background: #fff;
    font-size: 14px;
    border-radius: 5px;
    overflow: hidden;
    font-family: "open sans", serif;
    box-shadow: 3px 3px 6px #0000000D;
    border: 1px solid #E4EDFA;

    .ScenarioHistoryBodyLeft {
        border-right: 1px solid #E4EDFA;
        width: 450px;
    }

    b {
        font-family: "open sans semi", serif;
    }

    .btn-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        line-height: 28px;
        padding: 0 12px;
        font-size: 11px;
        text-transform: uppercase;
        font-family: "open sans semi", serif;
        white-space: nowrap;
        background: #EEF6FF;
        color: #0052CC;
        margin-right: 8px;
        border-radius: 5px;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
            background: #C4DAF6;
        }
    }

    .btn-menu {
        background: #EEF6FF;
        user-select: none;
    }
}

.log-container {
    height: calc(100vh - 299px);
    overflow-y: auto;

    .log-item {
        padding: 12px;
        border-bottom: 1px solid #E4EDFA;
        cursor: pointer;

        .log-item-name {
            font-family: "open sans bold", serif;
        }

        &.active {
            background: #e4edfa;
            color: #0052CC;
        }
    }
}

.message {
    cursor: pointer;
}

.nlp-container {
    text-align: left;
    font-size: 12px;
    margin-left: 10px;
    margin-top: 3px;
}

.item-container {
    background: #fff;
    width: 200px;
}

.item {
    font-size: 14px;
    color: #16171D;
    border-bottom: 1px solid #EDEDF2;
    padding: 10px;
    cursor: pointer;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #ccc;
    }
}

.audio-custom {
    height: 40px;
    width: 312px;
    border: 1px solid #FFFFFF;
    border-radius: 0 12px 12px 12px;
}

.call-audio {
    display: flex;
    align-items: center;

    audio {
        width: 100%;
        height: 30px;
    }
}

.filter-chip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    border: 1px solid #DBDBDB;
    border-radius: 5px;
    cursor: pointer;
    flex: 1;
    color: #818181;

    &:nth-child(2), &:nth-child(3) {
        flex: 2;
    }
}

.chip-activated {
    background: #0052CC;
    color: #FFF;
    border-color: #0052CC;
}

.no-data {
    flex-direction: column;
    margin-top: 64px;

    img {
        width: 40%;
    }

    .no-data-title {
        margin-top: -12px;
        font-family: "open sans semi", serif;
        font-size: 16px;
        color: #545253;
    }

    .no-data-des {
        color: #9A9A9A;
        font-size: 13px;
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}
</style>
